import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { line, softline } from '../slang-printers/prettier-builders.js';
import { printSeparatedList } from '../slang-printers/print-separated-list.js';
import { SlangNode } from './SlangNode.js';
import { UsingDeconstructionSymbol } from './UsingDeconstructionSymbol.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { AstPath, Doc, ParserOptions } from 'prettier';
import type { CollectedMetadata, PrintFunction } from '../types.d.ts';
import type { PrintableNode } from './types.d.ts';

export class UsingDeconstructionSymbols extends SlangNode {
  readonly kind = NonterminalKind.UsingDeconstructionSymbols;

  items: UsingDeconstructionSymbol[];

  constructor(
    ast: ast.UsingDeconstructionSymbols,
    collected: CollectedMetadata
  ) {
    super(ast, collected, true);

    this.items = ast.items.map(
      (item) => new UsingDeconstructionSymbol(item, collected)
    );
  }

  print(
    print: PrintFunction,
    path: AstPath<UsingDeconstructionSymbols>,
    options: ParserOptions<PrintableNode>
  ): Doc {
    return printSeparatedList(path.map(print, 'items'), {
      firstSeparator: options.bracketSpacing ? line : softline
    });
  }
}
